import showToast from '@util/ToastUtil'

function errorHandler(error) {
  if (error.response) {
    if (error.response.data.errorMessages) {
      const { errorMessages } = error.response.data

      const extractErrorMessages = () => {
        return errorMessages.map((msg) => {
          const parts = msg.split(':')
          if (parts.length > 1) {
            return parts[1].trim()
          }
          return ''
        })
      }

      const extractedMessages = extractErrorMessages()

      const displayToast = (messages, index = 0) => {
        if (index < messages.length) {
          showToast('error', messages[index], error.response.data.error)
          setTimeout(() => displayToast(messages, index + 1), 500)
        }
      }

      displayToast(extractedMessages)

    } else if (error.response.data.message) {
      if (error.response.data.message.search(':') === -1) {
        showToast('error', error.response.data.message, error.response.data.error)
      } else {
        const errorLabel = error.response.data.message.split(':')
        showToast('error', errorLabel[1], error.response.data.error)
      }
    }
  } else {
    showToast('error', 'Ocorreu um erro inesperado', error.data.error)
  }
}

export default errorHandler
